var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"partner-link",attrs:{"href":_vm.partner.link,"target":"_blank","rel":"noopener"}},[_c('img',{attrs:{"src":require('../../assets/' + _vm.partner.image + ''),"alt":_vm.partner.name}})])}
var staticRenderFns = []

export { render, staticRenderFns }